var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcepts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6011 10.0421C7.87416 10.4293 7.00003 11.4 7.00003 11.4V2.11306C7.00003 2.11306 5.6907 0.658664 1.27631 0.599997C1.20308 0.599074 1.13262 0.62795 1.08111 0.679997C1.02908 0.73227 0.999929 0.803049 1.00004 0.876796V9.61011C0.998816 9.75956 1.11731 9.88256 1.26671 9.88691C5.68963 9.94664 7.00003 11.4 7.00003 11.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 2.11306C7.00003 2.11306 8.30936 0.658664 12.7237 0.599997C12.797 0.599074 12.8674 0.62795 12.9189 0.679997C12.971 0.73227 13.0001 0.803049 13 0.876796V7.39998",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 10.0341V7.69278C10.6023 7.52913 10.7366 7.3982 10.9003 7.39998H13L10.6 10.0341Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcepts);
export default __webpack_public_path__ + "static/media/concepts.4232a4a73b4d4b7898edaf4758d22b1a.svg";
export { ForwardRef as ReactComponent };